/* ============================================================================
   BlueBox — Registro: la cédula solo acepta números

   El campo dice "sin guiones ni espacios" desde siempre, pero no lo verificaba:
   medido el 19 de agosto de 2026, "113-2108-79" pasaba como válido y se
   guardaba así en la base. Once caracteres cumplían el mínimo de nueve, y no
   había ninguna regla sobre qué caracteres eran.

   Que se guarde con guiones no es cosmético: el número de identificación es
   con lo que el cliente entra al portal y con lo que se lo busca en bodega. Si
   se registró con guiones y después lo escribe sin ellos, no entra.

   Se resuelve con el mismo validador que ya usa el formulario
   (jquery-validate, configurado con errorElement span y errorClass is-invalid),
   así el mensaje se ve igual que los demás y bloquea el envío igual que ellos.

   Este archivo se carga DESPUÉS de register.js a propósito: `rules('add')`
   necesita que el validador del formulario ya exista, y las funciones que
   jQuery encola con `jQuery(fn)` corren en el orden en que se registraron.
   ========================================================================== */

jQuery(function ($) {
    'use strict';

    var $campo = $('#Identification');
    if (!$campo.length || !$.validator || !$campo.closest('form').data('validator')) { return; }

    $.validator.addMethod('bbSoloNumeros', function (valor, elemento) {
        return this.optional(elemento) || /^[0-9]+$/.test(valor);
    }, 'Escribí solo números, sin guiones ni espacios.');

    $campo.rules('add', { bbSoloNumeros: true });

    /* Cuándo se revisa, para no regañar a quien todavía está escribiendo:

       - Al salir del campo: siempre, si escribió algo.
       - Mientras escribe: solo si hay un carácter que no es número —ahí el
         aviso es útil de inmediato— o si el campo ya está marcado en error,
         para que el mensaje desaparezca en cuanto lo corrija.

       Si se revisara en cada tecla, al segundo dígito ya estaría diciendo que
       faltan caracteres para el mínimo de nueve. */
    function tieneAlgoQueNoEsNumero() {
        return /[^0-9]/.test($campo.val() || '');
    }

    $campo.on('input', function () {
        if (tieneAlgoQueNoEsNumero() || $campo.hasClass('is-invalid')) {
            $campo.valid();
        }
    });

    $campo.on('blur', function () {
        if (($campo.val() || '').length) { $campo.valid(); }
    });
});
